var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",class:this.$store.consultasStore.state.selectedType === 3 || this.$store.consultasStore.state.selectedType === 4 ? 'scrollable-list-bak':'',staticStyle:{"height":"100vh"},attrs:{"fluid":"","pa-0":""}},[_c('FullHeader'),_c('ConsultasContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }